module.exports = __webpack_public_path__ + "static/media/box-nosize.dd06fd70.png";